module.exports = __webpack_public_path__ + "img/selection-poster_cn.cc6cce2.jpg";